import './App.css';
import Header from './Header';
import Home from './Homebody';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Checkout from './Checkout';

function App() {
  return (

    <Router>

      <div className="app">
        <Routes>

          {/* < Route path='/checkout'>
            <Header />
            <Checkout /> */}

          <Route path="/Checkout" element={<><Header/><Checkout /></>} />
          


          <Route path="/" element={<> <Header /> <Home /> </>} />
       

        </Routes>

      </div>

    </Router>
    
  );
  
}

export default App;
